var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanFilterButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 31,
    rx: 3.5,
    stroke: "#244C84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27979 19.3333V20.6667H13.2798V19.3333H9.27979ZM9.27979 11.3333V12.6667H15.9465V11.3333H9.27979ZM15.9465 22V20.6667H21.2798V19.3333H15.9465V18H14.6131V22H15.9465ZM11.9465 14V15.3333H9.27979V16.6667H11.9465V18H13.2798V14H11.9465ZM21.2798 16.6667V15.3333H14.6131V16.6667H21.2798ZM17.2798 14H18.6131V12.6667H21.2798V11.3333H18.6131V10H17.2798V14Z",
    fill: "#2F4B82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFilterButton);
export default __webpack_public_path__ + "static/media/planFilterButton.3df84a2302c17bbb9446b4b634958b7b.svg";
export { ForwardRef as ReactComponent };